Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.DateTimeField = (function() {
  function DateTimeField() {
    Monet.UI.Fields.DateField.apply(this, arguments);

    this.value = "";
    var baseElement = null;

    this.createElement = function() {
      if (!baseElement) {
        this.input = document.createElement("input");

        this.input.type = "text";
        this.input.className = "dateTimeField";
        this.input.autocomplete = "off";

        if (this.maxSize) {
          this.input.maxLength = this.maxSize;
        }

        this.setInputValue();
        baseElement = this.input;
        this.rootEl.appendChild(this.input);
      }
    };

    this.getValue = function() {
      return this.getFilterValue();
    };

    this.getFilterValue = function() {
      if (this.input) {
        this.value = this.input.value;
      }
      return Monet.Format.DateTime.parseLocaleToISOString(this.input.value);
    };

    this.setValue = function(value) {
      this.value = value || this.value;
      this.setInputValue();
    };

    this.setInputValue = function() {
      if (this.input && this.value) {
        this.input.value = Monet.Format.DateTime.formatToLocale(this.value);
      }
    };

    this.initializeSpecialBehavior = function() {
      const monetDateFormat = Monet.I18n.locale.dateFormat.toLowerCase();
      this.jdDateFormat = monetDateFormat.replace("yyyy", "yy");

      const extraOptions = {
        beforeShow: (input, dpInst) => {
          dpInst.dpDiv.css({
            top: "50px",
            left: "50px"
          });
        },
      };

      new Monet.Date.GeneralFunctions().setDateTimePicker(
        this.input,
        extraOptions
      );

      this.setListenerFocusOnEntityField(this.input);
    };

    this.render = function() {
      this.createElement();
      this.initializeSpecialBehavior();
      return this.rootEl;
    };
  }

  return DateTimeField;
})();
